<app-page-hero-redesign
  [title]="'Solutions'"
  [backgroundImage]="'assets/img/redesign/solutions/hero-page-bg.png'"
  [breadcrumbs]="[
    { label: 'Home', url: '/home-redesign' },
    { label: 'Solutions' }
  ]">
</app-page-hero-redesign>
<app-solutions-overview-redesign></app-solutions-overview-redesign>
<app-cta-redesign
    [title]="'Build a More Predictive Model of Mental Healthcare'"
    [description]="'Althea Soft helps institutions move from fragmented, reactive care to a more connected and preventive approach.'">
</app-cta-redesign>